import React, { useCallback, useState } from 'react';
import { Box, Detail, MainDiv, Tag } from './styles';
import Button from '../../../../component/button';
import Modal from '../../../../component/modals/modal';
import CreateTemplateModal from '../../../../component/modals/createTemplateModal';
import { trackAnalyticActivity } from '../../../../services/analyticsService';
import { PROJECT_ANALYTICS } from '../../../../global/analyticsConstants';
import { BUTTON_TYPE } from '../../../../global/constants';

interface Props {
  heading: string;
  isProject?: boolean;
  isTask?: boolean;
  onClickTaskTemplate?: () => void;
}
export default function Card(Props: Props) {
  const { heading, isProject, isTask, onClickTaskTemplate } = Props;
  // States
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Opens the create template modal and tracks analytics
  const onClickProjectTemplate = () => {
    trackAnalyticActivity(PROJECT_ANALYTICS.TEMPLATE_CREATE_CLICKED);
    setIsModalOpen(true);
  };

  // Closes the create template modal
  const onCloseTemplateModal = () => {
    setIsModalOpen(false);
  };

  // Handles click event based on template type (project or task)
  const handleCreateTemplate = useCallback(() => {
    if (isProject) {
      onClickProjectTemplate();
    } else {
      onClickTaskTemplate?.();
    }
  }, [isProject, onClickTaskTemplate]);

  return (
    <>
      <MainDiv>
        <Box>
          <Detail>{heading}</Detail>
          {(isProject || isTask) && (
            <Button title='Create Template' variant={BUTTON_TYPE.PRIMARY} size='small' onClick={handleCreateTemplate} />
          )}
          {!isProject && !isTask && <Tag>Coming soon</Tag>}
        </Box>
      </MainDiv>
      <Modal open={isModalOpen} onClose={onCloseTemplateModal} maxWidth={'400px'}>
        <CreateTemplateModal onCancel={onCloseTemplateModal} />
      </Modal>
    </>
  );
}
